import svc = require("./Service");
import $ = require("jquery");

export class Service {
    private serviceUrl: string;
    constructor(serviceUrl?: string) {
        if (serviceUrl) {
            this.serviceUrl = serviceUrl;
        } else {
            var globals = svc.globalPageData();
            this.serviceUrl = globals.urls.validateCfoapal;
        }
    }

    validatCfoapal(cfoapal: string): Promise<boolean> {
        var p = new Promise<boolean>((resolve, reject) => {
            var xhr = $.post(this.serviceUrl, { cfoapal: cfoapal });
            xhr.done((result) => {
                resolve(result);
            }).fail((error) => {
                reject(error);
            });
        });
        return p;

    }
}
